export const IconReRouteHover = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="34"
      viewBox="0 0 36 34"
      fill="none"
    >
      <path
        d="M10 18H25.0005"
        stroke="#245CEA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25 26H10"
        stroke="#245CEA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.0001 13.9925C13.2094 13.9925 15.0003 12.2016 15.0003 9.99234C15.0003 7.78312 13.2094 5.99219 11.0001 5.99219C8.7909 5.99219 7 7.78312 7 9.99234C7 12.2016 8.7909 13.9925 11.0001 13.9925Z"
        fill="#245CEA"
        stroke="#245CEA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.0001 30.0003C22.7909 30.0003 21 28.2094 21 26.0001C21 23.7909 22.7909 22 25.0001 22C27.2093 22 29.0003 23.7909 29.0003 26.0001C29.0003 28.2094 27.2093 30.0003 25.0001 30.0003Z"
        fill="#245CEA"
        stroke="#245CEA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 10L25 10"
        stroke="#245CEA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.998 18.0003V10"
        stroke="#245CEA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 26.0003V18"
        stroke="#245CEA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
